import {
	browserTracingIntegration,
	init,
	tanstackRouterBrowserTracingIntegration,
} from "@sentry/react";
import type { AnyRouter } from "@tanstack/react-router";

export function initSentry(router: AnyRouter): void {
	const dsn = import.meta.env.VITE_SENTRY_DSN;
	if (!dsn) {
		return;
	}

	init({
		dsn,
		environment: import.meta.env.MODE,

		sendDefaultPii: true,

		integrations: [
			browserTracingIntegration(),
			tanstackRouterBrowserTracingIntegration(router),
		],

		tracesSampleRate: import.meta.env.PROD ? 0.01 : 0,

		enableLogs: true,
	});
}
